import type * as monacoEditor from "monaco-editor/esm/vs/editor/editor.api";

export interface TranslationMatch {
  range: monacoEditor.Range;
  text: string;
}

/**
 * Find all matches of the translation pattern in the content
 * and return the matches as an array of TranslationMatch objects.
 *
 * @param content - The content to search for translation matches
 * @param callback - A function that processes each match and returns a TranslationMatch
 * @returns An array of TranslationMatch objects
 */
export const findTranslationMatches = (
  content: string,
  callback: (match: RegExpExecArray) => TranslationMatch
): TranslationMatch[] => {
  // Array to store all matches
  const matches: TranslationMatch[] = [];

  // Pattern to match the translation tag
  const pattern = /{%\s*translation\s+([a-zA-Z0-9_]+(?:(?!\s+%)%[^%\s]*)*)\s*%}[\s\S]*?{%\s*endtranslation\s*%}/gm;

  // Find all matches
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(content)) !== null) {
    matches.push(callback(match));
  }

  // Return all matches
  return matches;
};
